import { render } from "./SubscriptionPlans.vue?vue&type=template&id=5575c5c3&scoped=true"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=js"

import "./SubscriptionPlans.vue?vue&type=style&index=0&id=5575c5c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5575c5c3"]])

export default __exports__